<template>
  <card title="Ad Information">
    <v-container grid-list-md >
      <v-layout wrap>

        <v-flex
          xs4
          sm4
          sd4
        >
          <label>Picture</label>
          <el-upload
            :action="actionUrl"
            :show-file-list="false"
            :headers="{ Authorization: 'Bearer ' + token }"
            :data="{ type: 'ad' }"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            class="ad-picture-uploader"
            name="image"
          >
            <el-image
              v-if="editedItem.picture_urls"
              :src="editedItem.picture_urls"
              fit="fill"/>

            <i
              v-else
              class="el-icon-plus ad-picture-uploader-icon"/>
          </el-upload>
        </v-flex>
        <v-flex
          xs12
          sm2
          md2>
          <base-input
            v-model="editedItem.id"
            :disabled="true"
            required
            label="Ad Id"
          />
        </v-flex>
        <v-flex
          xs12
          sm12
          md12>
          <div class="form-group">
            <label class="control-label">
              {{ $t("dashboard.publish_start") }}
            </label>
            <!--                        <div class="demonstration">Value: {{ editedItem.publish_start }}</div>-->
            <div class="date-picker-wrapper">
              <el-date-picker
                v-model="editedItem.publish_start"
                class="date-picker"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"/>
            </div>
          </div>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12>
          <div class="form-group">
            <label class="control-label">
              {{ $t("dashboard.publish_end") }}
            </label>
            <!--                        <div class="demonstration">Value: {{ editedItem.publish_start }}</div>-->
            <div class="date-picker-wrapper">
              <el-date-picker
                v-model="editedItem.publish_end"
                class="date-picker"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"/>
            </div>
          </div>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12>
          <base-input
            v-model="editedItem.business"
            :label= "$t('dashboard.business')"
            required />
        </v-flex>
        <v-flex
          xs12
          sm5
          md5>
          <base-input
            v-model="editedItem.display_order"
            :label= "$t('dashboard.display_order')"
            required
            type="number"/>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12>
          <base-checkbox
            v-model="editedItem.active"
          > {{ $t("dashboard.active") }} </base-checkbox>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>
      <base-button
        @click="close">Cancel</base-button>

      <v-spacer/>
      <base-button
        type="primary"
        @click="save">Save</base-button>
    </v-card-actions>
  </card>
</template>

<style>

.ad-picture-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.ad-picture-uploader .el-upload:hover {
  border-color: #409EFF;
}

.ad-picture-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 99px;
  height: 99px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px !important;
  height: 178px;
  display: block;
}

</style>

<script>
import axios from 'axios'
import BaseButton from '@/components/BaseButton'
import { mapState } from 'vuex'

export default {
  components: { BaseButton },
  props: {
    item: {
      type: Object,
      default: {}
    },
    editedIndex: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    initialId: '',
    editedItem: {
      id: '',
      picture_urls: '',
      publish_start: '',
      publish_end: '',
      business: '',
      display_order: '',
      active: true
    }
  }),
  computed: {
    ...mapState(['token']),
    actionUrl: function () {
      return process.env.VUE_APP_API_BASE_URL + '/images/'
    }
  },
  mounted () {
    if (Object.keys(this.item).length !== 0) {
      this.editedItem = this.item
      this.initialId = this.editedItem.id
    }
  },
  methods: {

    close () {
      this.$emit('close')
    },
    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/ggs/' + this.initialId, this.editedItem)
          .then((response) => {
            this.$emit('update', response.data)
            this.editedItem = response.data
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/ggs', this.editedItem)
          .then((response) => {
            this.$emit('create', response.data)
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
    },

    handleAvatarSuccess (res) {
      this.editedItem.picture_urls = res.path
      this.$store.state.spinning = false
    },

    beforeAvatarUpload (file) {
      var mimes = ['image/png', 'image/jpeg', 'image/gif', 'image/jpg']
      const isValid = mimes.includes(file.type)
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isValid) {
        this.$message.error(
          '图片必须是以下类型的图片 JPG, JPEG, GIF or GIF format!'
        )
      }
      if (!isLt50M) {
        this.$message.error('图片最大不超过50MB!')
      }
      this.$store.state.spinning = true
      return isValid && isLt50M
    },

    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    }
  }
}
</script>
